import cls from "./customInnerPage.module.scss";
import React, {Dispatch, FC, ReactNode, SetStateAction} from "react";
import InputNumber from "../../shared/InputNumber";
import {setFormPopupOpen} from "../../../store/formbuilder";
import {useDispatch} from "react-redux";
import {IFormComponentType} from "../../builder/types";
import {IRequestFormDetails} from "../../../pages/[productSlug]";

interface ICustomSideBar {
    ProductAddToCart_INTL: string;
    actionClassName: string;
    handleCardClick: (quantity: number) => Promise<void>;
    isButtonDisabled: boolean;
    wishListButtonClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    wishIconClicked: ReactNode;
    minimalQty: number;
    maximalQty: number;
    inpValQuantity: number;
    setQuantity: Dispatch<SetStateAction<number>>;
    requestFormInfo: IFormComponentType | null;
    requestFormDetails: IRequestFormDetails;
    showWishlist: boolean
}

const CustomSideBar: FC<ICustomSideBar> = (
    {
        ProductAddToCart_INTL,
        actionClassName,
        handleCardClick,
        isButtonDisabled,
        wishListButtonClick,
        wishIconClicked,
        minimalQty,
        maximalQty,
        inpValQuantity,
        setQuantity,
        showWishlist,
        requestFormDetails,
        requestFormInfo
    }
) => {
    const dispatch = useDispatch();
    const Button = (
        {className = "", title = ProductAddToCart_INTL, onClick = () => handleCardClick(inpValQuantity), isButtonDisabledInside = false}
            : {className?: string, title?: string, onClick?: () => any, isButtonDisabledInside?: boolean}
    ) => {
        return <div
            className={`${cls["product__actions-item"]} ${cls["product__actions-item--addToCart"]}`}>
            <div className={`${cls["product__actions-item"]} ${cls["product__actions-item--addToCart"]} ${actionClassName}`}>
                <button
                    onClick={async (e) => {
                        e.preventDefault();
                        await onClick()
                    }}
                    disabled={isButtonDisabledInside}
                    className={`btn btn-orange ${cls["inner-addToCart"]} ${cls["rounded-pills"]} btn-lg ${className}`}
                >
                    {title}
                </button>
            </div>
        </div>
    }
    const hasWishlist = {
        "true": <div className={`${cls["product__actions-item"]}
                ${cls["product__actions-item--wishlist"]}
                ${cls["liked-button-wrapper"]}
                ${requestFormDetails?.requestFormBtn ? cls["like-btn-self-flex"] : ""}
            `}>
            <span>
                <button
                    aria-label="Wish list"
                    title="Wishlist"
                    onClick={wishListButtonClick}
                    className="btn-light btn-svg-icon btn-svg-icon--fake-svg"
                >
                    <div className={cls["wishlist-icon-wrapper"]}>
                        {wishIconClicked}
                    </div>
                </button>
            </span>
        </div>,
        "false": null
    }

    return (
        <div className={cls["product__sidebar"]}>
            <form className={cls["product__options"]}>
                <div className={`form-group ${cls["product__option"]}`}>
                    <div className={cls["product__actions"]}>
                        <div className={`${cls["product__actions-item"]} ${cls["product-inner-quantity"]}`}>
                        <InputNumber
                                id="product-quantity"
                                aria-label="Quantity"
                                className={cls["product__quantity"]}
                                size="lg"
                                min={minimalQty}
                                max={maximalQty}
                                value={inpValQuantity}
                                onChange={(quantity: number) => {
                                    if (quantity > maximalQty) {
                                        setQuantity(maximalQty)
                                    } else {
                                        setQuantity(quantity)
                                    }
                                }}
                            />
                        </div>
                        <div className={cls["inner-buttons-wrapper"]}>
                            <Button isButtonDisabledInside={isButtonDisabled}/>
                            {Number(requestFormDetails?.requestFormActive) && requestFormDetails?.requestFormBtn ? (
                                <Button
                                    isButtonDisabledInside={false}
                                    className={"inner-request-form-button"}
                                    title={requestFormDetails?.requestFormBtn}
                                    onClick={() => dispatch(setFormPopupOpen({
                                        id: requestFormInfo?.data?.id,
                                        open: true
                                    }))}
                                />
                            ) : null}
                        </div>
                        {hasWishlist[`${showWishlist}`]}
                    </div>
                </div>
            </form>
        </div>
    )
}

export default CustomSideBar;
